import { ManifestComponentExtensionType } from '../stores';
import { CompRef } from '@wix/document-services-types';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export enum OperationSource {
  EDITOR = 'Editor',
  SDK = 'Sdk',
  UNKNOWN = 'Unknown',
}

export type BasePanoramaLoadData = {
  origin_id?: string;
  editor_pointer?: EditorPointer<CompRef>;
  component_type?: string;
  manifest_component_extension_type?: ManifestComponentExtensionType;
  source: OperationSource;
};

export type ApplyComponentResizePanoramaLoadData = BasePanoramaLoadData & {
  preset_key?: string;
};

export type SetStylesPanoramaLoadData = BasePanoramaLoadData & {
  styles?: {
    cssProperties?: Record<string, string>;
    cssCustomProperties?: Record<string, string>;
  };
};

export type ApplyPresetPanoramaLoadData = BasePanoramaLoadData & {
  preset_name: string;
};
